/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
/**
 * The internal dependencies.
 */
import userIcon from '../../../assets/images/temp/ico-user.png';
import compose from "ramda/es/compose";
import connect from "react-redux/es/connect/connect";
import {setOverlay} from "../../../store/tasks/actions";
import {withRouter} from "react-router-dom";

const Wrapper = styled.div`
	display flex;
	justify-conecnt: flex-end;
	align-items: flex-end;
	margin-right: 9px;
`;

const Info = styled.div`
	font-size: 8px;
	color: #95989a;
	margin-right: 9px;
`;

const BarUser = ({user, click}) => (
    <Wrapper onClick={click}>
        <Info>
            {`${user.fullname} ${user.workplace ? user.workplace : ''}`}
        </Info>

        <img src={user.avatar ? user.avatar : userIcon} alt="User Profile"/>
    </Wrapper>
);

export default BarUser;



// WEBPACK FOOTER //
// ./src/components/dashboard/bar/user.js